import {
  Button,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useAtomValue } from "jotai";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { selectedValuesAtom, voicesDescriptionAtom } from "atoms";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { titleCase } from "shared/utils/tts-custom-editor";
import { getVoiceDescription } from "shared/utils/tts";
import VoiceAvatarIcon from "features/TTS/components/VoiceAvatarIcon";
import LanguageVoiceCatalog from "./LanguageVoiceCatalog";
import { MenuBorderColor } from "shared/constants";
import { VoiceDescriptionProps } from "shared/models";

interface LanguageVoiceSettingsProps {
  stopEditorAudio: () => void;
}

export default function LanguageVoiceSettings({
  stopEditorAudio,
}: LanguageVoiceSettingsProps): JSX.Element {
  const { selectedVoice, selectedLanguage } = useAtomValue(selectedValuesAtom);
  const voicesDescription = useAtomValue(voicesDescriptionAtom);
  const voiceDescription: VoiceDescriptionProps | undefined =
    getVoiceDescription(selectedVoice, voicesDescription);

  const [showCatalog, setShowCatalog] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <>
      <Stack
        gap={2}
        sx={{
          border: `1px solid ${MenuBorderColor}`,
          borderBottom: 0,
        }}
      >
        <ListItem>
          {voiceDescription && (
            <VoiceAvatarIcon voiceDescription={voiceDescription} />
          )}
          <ListItemText
            primary={
              <Stack direction="row" alignItems="center" gap={0.5}>
                <Typography
                  variant="subtitle1"
                  color="text.primary"
                  display="inline"
                >
                  {voiceDescription
                    ? titleCase(voiceDescription.voiceName)
                    : selectedVoice}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.primary"
                  display="inline"
                >
                  in
                </Typography>
                <Typography
                  variant="body1"
                  color="text.primary"
                  display="inline"
                  style={{ fontStyle: "italic" }}
                >
                  {t(
                    `tts.toolbarMenu.languageMenu.${selectedLanguage.toLowerCase()}`
                  )}
                </Typography>
                <Button
                  variant="text"
                  onClick={() => {
                    stopEditorAudio();
                    setShowCatalog(true);
                  }}
                  id="change-button"
                  color="primary"
                  sx={{ minWidth: 0 }}
                >
                  <EditOutlinedIcon
                    onClick={() => {
                      stopEditorAudio();
                      setShowCatalog(true);
                    }}
                    id="change-button"
                    sx={{ color: "primary.main" }}
                  />
                </Button>
              </Stack>
            }
          />
        </ListItem>
      </Stack>
      {showCatalog && (
        <LanguageVoiceCatalog handleCloseDialog={() => setShowCatalog(false)} />
      )}
    </>
  );
}
